import Button from '../../../components/bootstrap/Button';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Icon from '../../../components/icon/Icon';
import Select from 'components/bootstrap/forms/Select';
import { FormGroup, Modal } from 'react-bootstrap';
import { useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';

export default function CreatePaimentFromDevisPopup({ setOpen, handleConfirm, handleCancel, totalAmount }) {
	const [choice, setChoice] = useState('30');
	const [loading, setLoading] = useState(false) // '30' | '100'

	const selectedAmount = useMemo(() => {
		const total = Number(totalAmount || 0);
		if (!total) return 0;
		return choice === '30' ? (total * 30) / 100 : total;
	}, [choice, totalAmount]);
	return (
		<Modal show={true} onHide={() => { }} centered fullscreen={isMobile}>
			{/* ================= HEADER ================= */}
			<Modal.Header className="border-0 justify-content-center">
				<div className="text-center">
					<Icon icon="Payments" color="info" size="5x" />
					<h2 className="mt-3 mb-0 fw-bold">Paiement</h2>
				</div>
			</Modal.Header>

			{/* ================= BODY ================= */}
			<Modal.Body className="d-flex align-items-center justify-content-center">
				<div className="text-center w-100" style={{ maxWidth: 420 }}>
					<p className="fs-5 mb-4">
						Souhaitez-vous effectuer le paiement maintenant ?
					</p>

					<FormGroup label="Choisissez le montant à payer">
						<Select
							id="payment-choice"
							ariaLabel="Choix du paiement"
							value={choice}
							onChange={(e) => setChoice(e.target.value)}
							list={[
								{ value: '30', text: 'Acompte 30%' },
								{ value: '100', text: 'Totalité' },
							]}
						/>
					</FormGroup>

					{/* 💰 AMOUNT */}
					<div className="mt-4">
						<div className="text-muted">Montant à payer</div>
						<div className="display-1 fw-bold text-info">
							{Math.round(Number(selectedAmount).toFixed(2))} €
						</div>
					</div>
				</div>
			</Modal.Body>

			{/* ================= FOOTER ================= */}
			<Modal.Footer className="border-0 gap-3">
				<div className="d-flex flex-column flex-lg-row w-100 gap-3">
					<Button
						color="info"
						className="w-100"
						size="lg"
						isDisable={loading}
						onClick={() => {
							setLoading(true)
							handleConfirm?.(selectedAmount);

						}}
					>
						{loading ? "En cours ..." : "Oui"}
					</Button>

					<Button
						color="info"
						isLight
						className="w-100"
						size="lg"
						onClick={() => {
							handleCancel?.();
							setOpen(false);
						}}
					>
						Non
					</Button>
				</div>
			</Modal.Footer>
		</Modal>

	);
}
